export default __webpack_public_path__ + "static/media/tokensBgMb.09419339.png";